import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { AdminAuthProvider, useAdminAuth } from "@/admin/AdminAuthContext";
import Home from "@/pages/Home";
import ApartmentDetail from "@/pages/ApartmentDetail";
import Booking from "@/pages/Booking";
import BookingConfirm from "@/pages/BookingConfirm";
import AdminLogin from "@/admin/AdminLogin";
import AdminDashboard from "@/admin/AdminDashboard";

function RequireAdmin({ children }) {
  const { token } = useAdminAuth();
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function App() {
  useEffect(() => { document.title = "MMSpacerents – Case vacanza a Milano"; }, []);
  return (
    <LanguageProvider>
      <AdminAuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/appartamento/:slug" element={<ApartmentDetail />} />
            <Route path="/prenotazione" element={<Booking />} />
            <Route path="/prenotazione/conferma" element={<BookingConfirm />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
          </Routes>
        </BrowserRouter>
      </AdminAuthProvider>
    </LanguageProvider>
  );
}
